<div class="w-full rounded-full  overflow-hidden" [ngClass]="secondColorClass">
  <div [ngClass]="singleColor ? 'bg-primary' :{
              'bg-vw-premium-accent': progress < 70,
              'bg-vw-primary': progress >= 70
            }" [style.height.px]="10" [style.width.%]="progress"></div>
</div>